import CircularAnalytics from './circularAnalytics';
export default CircularAnalytics;